import { render, staticRenderFns } from "./footgame.vue?vue&type=template&id=91534d42&scoped=true&"
import script from "./footgame.vue?vue&type=script&lang=js&"
export * from "./footgame.vue?vue&type=script&lang=js&"
import style0 from "./footgame.vue?vue&type=style&index=0&id=91534d42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91534d42",
  null
  
)

export default component.exports